export let AddonId = /*#__PURE__*/function (AddonId) {
  AddonId["AGENCY_USER"] = "agency_user";
  AddonId["CORE_USER"] = "core_user";
  AddonId["COVERAGE_INTEGRATION_AUXIPRESS"] = "coverage_integration_auxipress";
  AddonId["COVERAGE_INTEGRATION_BELGA"] = "coverage_integration_belga";
  AddonId["COVERAGE_INTEGRATION_GOOGLE_ALERTS"] = "coverage_integration_google_alerts";
  AddonId["COVERAGE_INTEGRATION_NETFEEDR"] = "coverage_integration_netfeedr";
  AddonId["COVERAGE_INTEGRATION_OPOINT"] = "coverage_integration_opoint";
  AddonId["COVERAGE_INTEGRATION_RSS"] = "coverage_integration_rss";
  AddonId["PREMIUM_USER"] = "premium_user";
  AddonId["SITE"] = "site";
  AddonId["STANDARD_USER"] = "standard_user";
  AddonId["STARTER_USER"] = "starter_user";
  return AddonId;
}({});
export let ChangeType = /*#__PURE__*/function (ChangeType) {
  ChangeType["ACTIVATION"] = "activation";
  ChangeType["UPGRADE"] = "upgrade";
  ChangeType["DOWNGRADE"] = "downgrade";
  return ChangeType;
}({});

/** @deprecated Will be dropped in future */
export let PlanLevel = /*#__PURE__*/function (PlanLevel) {
  PlanLevel["AGENCY_ESSENTIAL"] = "agency_essential";
  PlanLevel["AGENCY_HUGE"] = "agency_huge";
  PlanLevel["AGENCY_LARGE"] = "agency_large";
  PlanLevel["AGENCY_MEDIUM"] = "agency_medium";
  PlanLevel["AGENCY_SMALL"] = "agency_small";
  PlanLevel["AGENCY_STANDARD"] = "agency_standard";
  PlanLevel["BASIC"] = "basic";
  PlanLevel["CORE"] = "core";
  PlanLevel["ENTERPRISE"] = "enterprise";
  PlanLevel["ESSENTIAL"] = "essential";
  PlanLevel["EXPERT"] = "expert";
  PlanLevel["NONE"] = "";
  PlanLevel["PREMIUM"] = "premium";
  PlanLevel["PROFESSIONAL"] = "professional";
  PlanLevel["STANDARD"] = "standard";
  PlanLevel["STARTER"] = "starter";
  return PlanLevel;
}({});